<template>
  <Header />

  <div>
    <div class="login-form mt-5">
      <div class="section">
        <img src="assets/img/F2.png" alt="avatar" class="img-fluid avatar" :class="{ small: keyboardOpen }" />
      </div>

      <div class="section mt-3 mb-5">
        <form @submit.prevent="checkForm">
          <div class="form-group boxed">
            <div class="input-wrapper">
              <label class="form-label" for="mobileNumber">لطفا شماره موبایل خود را وارد کنید</label>

              <input type="tel" class="form-control text-start" id="mobileNumber" name="mobileNumber"
                v-model="postData.mobileNumber" @focus="handleKeyboardOpen" @blur="handleKeyboardClose"
                placeholder="مثال 09120000000" autocomplete="off" />

              <i class="clear-input">
                <ion-icon name="close-circle"></ion-icon>
              </i>
            </div>
          </div>

          <ul v-if="errors.length">
            <li v-for="(error, index) in errors" :key="index" class="invalid-feed">
              {{ error }}
            </li>
          </ul>

          <div class="form-group mt-2 mb-3">
            <div class="form-check mb-1">
              <input type="checkbox" class="form-check-input" id="acceptTerm" v-model="postData.acceptTerm" />

              <label class="form-check-label" for="acceptTerm">
                با ورود به اس بار
                <router-link class="text-warning" to="/terms-and-conditions">قوانین و مقررات</router-link>
                را میپذیرم.
              </label>
            </div>
          </div>

          <div class="form-button-group">
            <button v-if="!loading" class="btn background-blue text-light btn-block btn-lg">
              درخواست کد فعال سازی
            </button>

            <button v-else class="btn background-blue text-light btn-block btn-lg" type="button" disabled>
              <span class="spinner-border spinner-border-sm"></span>
              درحال بررسی ...
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
import Header from "@/components/HeaderHome.vue";
import axios from "axios";

export default {
  components: { Header },

  data() {
    return {
      errors: [],
      keyboardOpen: false,
      postData: {
        mobileNumber: "",
        acceptTerm: null,
      },
      loading: false,
    };
  },

  methods: {
    handleKeyboardOpen() {
      this.keyboardOpen = true;
      if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler("scrollRequest", {
          y: window.scrollY,
        });
      }
    },

    handleKeyboardClose() {
      this.keyboardOpen = false;
    },

    checkForm() {
      this.errors = [];

      if (!this.postData.mobileNumber) this.errors.push("شماره موبایل اجباری است.");
      if (!this.postData.acceptTerm) this.errors.push("قبول قوانین و مقررات اجباری است.");
      if (this.postData.mobileNumber.length < 11) this.errors.push("شماره موبایل باید 11 رقم باشد.");

      if (this.errors.length === 0) this.createPost();
    },

    createPost() {
      this.loading = true;

      axios
        .post("https://xpanel.s-bar.ir/api/requestActivationCode", this.postData)
        .then((response) => {
          this.loading = false;

          if (response.data.status === "success") {
            this.$router.replace({
              name: "verify",
              params: { mobileNumber: this.postData.mobileNumber },
            });
          } else {
            alert(response.data.result);
          }
        });
    },
  },
};
</script>


<style scoped>
.avatar {
  width: 180px;
  transition: all 0.3s ease;
}

.avatar.small {
  width: 80px;
  opacity: 0.9;
}

.invalid-feed {
  color: #dc3545;
  font-size: 0.875em;
  margin-top: 5px;
}
</style>
